import { Switch, Route } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { Session } from '../pages/Session';
import { LoginForm } from '../pages/Login';
import { PrivateRoute } from './PrivateRoute';
import { AccessDenied } from '../pages/AccessDenied';
import { ChangePasswordForm } from '../pages/ChangePassword';
import { ForgotPassword } from '../pages/ForgotPassword';
import { PageLoadingError } from '../pages/PageLoadingError';
import { EmailConfirmationLanding } from '../pages/EmailConfirmationLanding';
import GcpSignup from '../pages/GcpSignup';
import { UploadInitialData } from '../pages/UploadInitialData';
import UpsVerifyPage from '../pages/UpsVerifyPage';
import TrackingStatusPage from '../pages/TrackingStatusPage';
import Logout from '../pages/Logout';
import SingleSignOn from '../pages/SingleSignOn';

export const AppRouter = () => {
  return (
    <CompatRouter>
      <Switch>
        <Route path="/session" component={Session} />
        <Route path="/login" component={LoginForm} />
        <Route path="/logout" component={Logout} />
        <Route path="/sso" component={SingleSignOn} />
        <Route path="/callback" component={LoginForm} />
        <Route path="/loading-error" component={PageLoadingError} />
        <Route path="/verify-email/:token" component={EmailConfirmationLanding} />
        <Route path="/upload-initial-data" component={UploadInitialData} />
        <Route path="/account/:token/change-password" component={ChangePasswordForm} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/access-denied" component={AccessDenied} />
        <Route path="/ups-verify" component={UpsVerifyPage} />
        <Route path="/trackingviz" component={TrackingStatusPage} />
        <Route path="/gcp-signup" component={GcpSignup} />
        {/* Dynamic route, ordering  matters */}
        <Route component={PrivateRoute} />
      </Switch>
    </CompatRouter>
  );
};
